import { useEffect, useState } from "react";

function MyOrders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return;

    fetch(`http://kolibusiness.com/backend/api-myorders.php?user_id=${user.id}`)
      .then(res => res.json())
      .then(data => setOrders(data));
  }, []);

  return (
    <div style={{ padding: "30px" }}>
      <h2>My Orders</h2>
      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        orders.map((order, index) => (
          <div key={index} style={{ marginBottom: "30px", padding: "20px", border: "1px solid #ddd", borderRadius: "10px" }}>
            <h4>Order #{order.id}</h4>
            <p><strong>Date:</strong> {order.created_at}</p>
            <p><strong>Payment:</strong> {order.payment_method}</p>
            <p><strong>Address:</strong> {order.address}</p>
            <p><strong>Total:</strong> ₹{order.total}</p>
            <h5>Items:</h5>
            <ul>
              {JSON.parse(order.cart).map((item, i) => (
                <li key={i}>
                  {item.title} - {item.price}
                </li>
              ))}
            </ul>
          </div>
        ))
      )}
    </div>
  );
}

export default MyOrders;
